<template>
  <v-sheet v-resize="onResize" class="product-swiper" elevation="0" rounded>
    <div class="d-flex justify-space-between">
      <p class="text-h6 mb-5">{{ title }}</p>
      <div class="swiper-btn-group d-flex">
        <v-btn
          class="swiper-button swiper-prev mr-3 pa-0"
          :class="{ hidden: hiddenSwiperBeginning }"
          min-width="32"
          height="32"
          variant="text"
          @click="prevSwiper"
        >
          <funnow-icon max-width="24" :image-path="'chevron-left.svg'" />
        </v-btn>
        <v-btn
          class="swiper-button swiper-next pa-0"
          :class="{ hidden: hiddenSwiperEnd }"
          min-width="32"
          height="32"
          variant="text"
          @click="nextSwiper"
        >
          <funnow-icon max-width="24" :image-path="'chevron-right.svg'" />
        </v-btn>
      </div>
    </div>

    <div class="default-swiper__container mt-2">
      <swiper
        ref="nearBranchesSwiper"
        class="swiper"
        v-bind="swiperOption"
        @swiper="onSwiper"
        @slide-change-transition-end="onSlideChangeEnd"
        @resize="onResize"
      >
        <swiper-slide v-for="(product, idx) in items" :key="idx">
          <ProductCard :product="product" :hide-rrp="isFunBookV2" :hide-rating="isFunBookV2" />
        </swiper-slide>
      </swiper>
    </div>
  </v-sheet>
</template>

<script>
import { mapGetters } from 'vuex'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { usePlatformStore } from '@/store-pinia/platform'

import ProductCard from '@/components/card/product.vue'
import FunnowIcon from '@/components/icons/funnow-icon.vue'
import { provideGtmSource } from '@/composition/useGtmSource'

const ONE_SWIPER_WIDTH = 290

export default {
  components: {
    Swiper,
    SwiperSlide,
    ProductCard,
    FunnowIcon,
  },
  props: {
    title: { type: String, default: '' },
    items: { type: Array, default: () => [] },
    source: { type: String, default: null },
  },
  setup(props) {
    provideGtmSource(props.source)

    const platformStore = usePlatformStore()
    const { isFunBookV2 } = storeToRefs(platformStore)

    return {
      isFunBookV2,
    }
  },
  data() {
    return {
      hiddenSwiperBeginning: true,
      hiddenSwiperEnd: true,
      swiper: null,
      swiperOption: {
        width: ONE_SWIPER_WIDTH,
        spaceBetween: 16,
      },
    }
  },
  mounted() {
    // this.initSwiperBtnStatus()
  },
  methods: {
    onResize(swiper) {
      this.updateSwiperButton(swiper)
      // this.initSwiperBtnStatus()
    },
    // initSwiperBtnStatus() {
    //   // console.log('this.$refs.nearBranchesSwiper: ', this.$refs.nearBranchesSwiper)
    //   // const $swiper = this.$refs.nearBranchesSwiper.$swiper
    //   // const swiperClientWidth = $swiper.el.getBoundingClientRect().width
    //   // if (ONE_SWIPER_WIDTH * this.items.length > swiperClientWidth) {
    //   //   this.hiddenSwiperEnd = false
    //   // }
    // },
    updateSwiperButton(swiper) {
      this.$nextTick(() => {
        this.hiddenSwiperBeginning = !!swiper?.isBeginning
        this.hiddenSwiperEnd = !!swiper?.isEnd
      })
    },
    prevSwiper() {
      this.swiper.slidePrev()
    },
    nextSwiper() {
      this.swiper.slideNext()
    },
    onSlideChangeEnd(swiper) {
      this.updateSwiperButton(swiper)
    },
    onSwiper(swiper) {
      this.swiper = swiper
      this.updateSwiperButton(swiper)
    },
  },
}
</script>

<style scoped lang="scss">
.swiper-btn-group {
  .swiper-button {
    &.hidden {
      visibility: hidden;
    }
  }
}
</style>
